/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![FileUpIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABYElEQVR4nN2VvUoDQRDHr7ISbFRsrH0N7UK4nZkrJjOCjb5DFKws8xA+gQiCVqkEbbTUiG9gqaAIxiqyuVvZu+Dthb00LgzHMcz/t/Oxu0nyrxaibALJuSH9ANLJX2ZQX10MQG+/sbgNrBMGz34B+f8gCLA7byoOs4AwJFQWqBgzL+dx8tIIMo84kE4QZbuIG5T7IyetAAzJpY1j5iULqWRyEA2AfLfHwebGAMAa6hVAb8f1pH0A1Z+ThQDAG+M2AGMg6WfZ3ro1g3oIJJ/tAFC+TKadqhYzr0QDDOq3IUltbId5zaDcG5K7NN1djW6yqYqTPHq+5y7zRgxg7MpSFa+FNAdI34kD6qg4CyPP/1R8H0rlanrZdYudGdJrJz6FFf7pJLmsUIdeBnIxDwBITy3EivsV8LIblm5XAN4Ckrdwg+WobkiS4JOJegYk77UThLOQRoCYtXgAyq0hvak6fgDc94QLVsq/XQAAAABJRU5ErkJggg==)
 */
export const FileUpIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M13.82 21.7c.17.05.14.3-.04.3H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h7.5c.28 0 .5.22.5.5V5a5 5 0 0 0 5 5h2.5c.28 0 .5.22.5.5v2.3a.4.4 0 0 1-.68.27l-.2-.2a3 3 0 0 0-4.24 0l-4 4a3 3 0 0 0 0 4.25c.3.3.6.46.94.58Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.66 8c.03 0 .05-.03.04-.06a3 3 0 0 0-.58-.82l-4.24-4.24a3 3 0 0 0-.82-.58.04.04 0 0 0-.06.04V5a3 3 0 0 0 3 3h2.66ZM18.3 14.3a1 1 0 0 1 1.4 0l4 4a1 1 0 0 1-1.4 1.4L20 17.42V23a1 1 0 1 1-2 0v-5.59l-2.3 2.3a1 1 0 0 1-1.4-1.42l4-4Z"
        className={colorClass}
      />
    </svg>
  );
};
